import { Navigate, Outlet, useParams } from "react-router-dom";
import { ReactElement } from "react";
import {
  isSupportedAnalysisEngineType,
  isKnownAnalysisEngineType,
} from "../../../types";
import { ENABLED_ENGINES } from "../../../environments";

export function EngineType(): ReactElement {
  const { engineType } = useParams();

  if (
    isKnownAnalysisEngineType(engineType) &&
    isSupportedAnalysisEngineType(engineType) &&
    ENABLED_ENGINES.includes(engineType)
  ) {
    return <Outlet />;
  } else {
    return <Navigate to="/404" replace />;
  }
}
